import { useState } from "react";
import { Link } from "react-router-dom";
import VideoCard from "@/components/feature/VideoCard";
import { videos } from "@/mocks/videos";
import { categories } from "@/mocks/categories";

export default function LatestVideos() {
  const [tab, setTab] = useState("all");

  const list = [...videos]
    .filter((v) => tab === "all" || v.category === tab)
    .sort((a, b) => a.daysAgo - b.daysAgo)
    .slice(0, 9);

  return (
    <section>
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div>
          <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950">最新上传</h2>
          <p className="mt-1 text-sm text-foreground-500">社区新鲜出炉的内容，第一时间看到</p>
        </div>
        <Link
          to="/search"
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="flex items-center gap-2 mb-5 flex-wrap">
        <button
          type="button"
          onClick={() => setTab("all")}
          className={`h-8 px-4 rounded-full text-sm cursor-pointer transition-colors whitespace-nowrap ${
            tab === "all"
              ? "bg-primary-500 text-background-50 font-semibold"
              : "bg-background-100 text-foreground-600 hover:text-primary-600"
          }`}
        >
          全部
        </button>
        {categories.map((cat) => (
          <button
            key={cat.slug}
            type="button"
            onClick={() => setTab(cat.slug)}
            className={`h-8 px-4 rounded-full text-sm cursor-pointer transition-colors whitespace-nowrap ${
              tab === cat.slug
                ? "bg-primary-500 text-background-50 font-semibold"
                : "bg-background-100 text-foreground-600 hover:text-primary-600"
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {list.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {list.map((v) => (
            <VideoCard
              key={v.id}
              id={v.id}
              title={v.title}
              cover={v.cover}
              author={v.author}
              category={v.category}
              views={v.views}
              duration={v.duration}
              publishDate={v.publishDate}
              authorType={v.authorType}
            />
          ))}
        </div>
      ) : (
        <p className="py-12 text-center text-sm text-foreground-500">该分类暂无内容，换个分类看看？</p>
      )}
    </section>
  );
}